import script from "./Rooms.vue?vue&type=script&setup=true&lang=js"
export * from "./Rooms.vue?vue&type=script&setup=true&lang=js"

import "./Rooms.vue?vue&type=style&index=0&id=2c089fd1&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c089fd1"]])

export default __exports__